// 暂时只有批量预约的config
export default {
    batchAppointTable: {
        height: 400,
        columns: [
            {
                prop: 'receiverMsg',
                label: '联系人信息',
                width: '280px',
                type: 'normal'
            },
            {
                prop: 'customerOrderNo',
                label: '客户订单号',
                width: '160px',
                type: 'normal'
            },
            {
                prop: 'taskNo',
                label: '任务号',
                width: '160px',
                type: 'normal'
            },
            {
				prop: 'isJzpName',
				label: '是否精准配送',
				width: '120px',
				type: 'normal'
			}
        ]
    },
     appointmentBranchTable: {
        height: 400,
        selection: true,
        columns: [
            {
                prop: 'customerOrderNo',
                label: '客户订单号',
                width: '220px',
                type: 'normal'
            },
            {
                prop: 'taskNo',
                label: '任务号',
                width: '160px',
                type: 'normal'
            },
            {
                prop: 'networkName',
                label: '网点名称',
                width: '220px',
                type: 'normal'
            },
            {
                prop: 'receiverMsg',
                label: '网点联系人信息',
                width: '400px',
                type: 'normal'
            },
            {
                prop: 'examineTime',
                label: '时效考核时间',
                width: '160px',
                type: 'normal'
            },
            {
                prop: 'taskStatusName',
                label: '任务状态',
                width: '120px',
                type: 'normal'
            },
            {
                prop: 'appointmentTimes',
                label: '上次预约时间',
                width: '160px',
                type: 'normal'
            },
            {
                prop: 'remark',
                label: '客户备注',
                width: '220px',
                type: 'normal'
            }
        ]
    }
};
